import { useQuery } from '@tanstack/react-query';
import { uptimeApi } from '@/api/endpoints/uptime';

// Status de disponibilidade dos sistemas (janela de 5h). Atualiza sozinho a cada
// 60s — o dado real vem da UptimeRobot via proxy da nossa API.
const UPTIME_POLL_MS = 60_000;

export function useUptime() {
  return useQuery({
    queryKey: ['uptime', 'status'],
    queryFn: () => uptimeApi.status(),
    refetchInterval: UPTIME_POLL_MS,
    staleTime: 30_000,
  });
}
